import React, { useEffect, useState } from 'react';
import MainMenu from './components/MainMenu';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const sticky = document.querySelector('.sticky-header');
      if (window.scrollY > 100) {
        sticky?.classList.add('stickactive');
      } else {
        sticky?.classList.remove('stickactive');
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Mobile nav fallback logic
    const mobileToggler = document.querySelectorAll('.mobile-nav-toggler');
    const mobileMenu = document.querySelector('.mobile-menu');
    const closeBtn = document.querySelector('.mobile-menu .close-btn');
    const backdrop = document.querySelector('.menu-backdrop');

    const openMenu = () => {
      mobileMenu?.classList.add('active');
      document.body.classList.add('mobile-menu-visible');
      console.log('Mobile menu opened');
    };

    const closeMenu = () => {
      mobileMenu?.classList.remove('active');
      document.body.classList.remove('mobile-menu-visible');
      console.log('Mobile menu closed');
    };

    mobileToggler.forEach(el => el.addEventListener('click', openMenu));
    closeBtn?.addEventListener('click', closeMenu);
    backdrop?.addEventListener('click', closeMenu);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      mobileToggler.forEach(el => el.removeEventListener('click', openMenu));
      closeBtn?.removeEventListener('click', closeMenu);
      backdrop?.removeEventListener('click', closeMenu);
    };
  }, []);

  return (
    <header className="main-header header-style-two">
      {/* Header Top */}
      <div className="header-top">
        <div className="auto-container">
          <div className="inner-container">
            <div className="top-left">
              <ul className="list-style-one">
                <li>
                  <i className="fa fa-envelope"></i>
                  <a href="mailto:muhasebe@flytime.com.tr">muhasebe@flytime.com.tr</a>
                </li>
                <li>
                  <i className="fa fa-map-marker"></i>
                  Hobyar Mah. Muhzırbaşı Sok. N0:3 İç Kapı:103 Atabay İş Mrkz. Sirkeci / Fatih - İSTANBUL
                </li>
              </ul>
            </div>
            <div className="top-right">
              <ul className="social-icon-one">
                <li><a href="#"><i className="fab fa-twitter"></i></a></li>
                <li><a href="#"><i className="fab fa-facebook-square"></i></a></li>
                <li><a href="#"><i className="fab fa-pinterest-p"></i></a></li>
                <li><a href="#"><i className="fab fa-instagram"></i></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Header Lower */}
      <div className="header-lower">
        <div className="auto-container">
          <div className="main-box">
            <div className="logo-box">
              <div className="logo">
                <a href="/"><img src="/assets/images/logo-2.png" alt="Tronis" title="Tronis" /></a>
              </div>
            </div>

            <div className="nav-outer">
            <nav className="main-menu">
              <MainMenu />
              </nav>
            </div>

            <div className="outer-box">
              <a className="theme-btn btn-style-one bg-theme-color3 danismanlik" href="/">
                <span className="btn-title">Danışmanlık Al</span>
              </a>
              <div className="mobile-nav-toggler d-lg-none" onClick={() => setIsMobileMenuOpen(true)}>
        <span className="icon lnr-icon-bars"></span>
      </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
        <div className="menu-backdrop" onClick={() => setIsMobileMenuOpen(false)}></div>
        <nav className="menu-box">
          <div className="upper-box">
            <div className="nav-logo">
              <a href="/"><img src="/assets/images/logo-2.png" alt="Logo" /></a>
            </div>
            <div className="close-btn" onClick={() => setIsMobileMenuOpen(false)}>
              <i className="icon fa fa-times"></i>
            </div>
          </div>

          {/* Navigation */}
          <MainMenu />

          {/* İsteğe bağlı: sosyal, iletişim bilgisi vs */}
        </nav>
      </div>

      {/* Sticky Header */}
      <div className="sticky-header">
        <div className="auto-container">
          <div className="inner-container">
            <div className="logo">
              <a href="/"><img src="/assets/images/logo.png" alt="Sticky Logo" /></a>
            </div>
            <div className="nav-outer">
             <nav className="main-menu">
              <MainMenu />
              </nav>
              <div className="mobile-nav-toggler" onClick={() => setIsMobileMenuOpen(true)}>
                <span className="icon lnr-icon-bars"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;